<template lang="pug">
  div(data-testid="card-tab-overall-socials")
    a.pull-right(v-if="editable" href="#" @click.prevent="openModal" data-testid="-link-update-social") 編集

    p.lead
      i.fa.fa-fw.fa-globe
      |
      |
      span ソーシャルサイト

    social-view(v-model="socials", :class="{'bcard-field-editted': isFieldEditted}")

    portal(to="modal")
      form(@submit.prevent="submit")
        app-modal(type="default" v-model="modalEdit.isOpen", data-testid="-modal-update-social")
          template(slot="title") ソーシャルサイトの変更
          social-form(v-model="modalEdit.value")
          template(slot="footer" slot-scope="{close}")
            button.btn.btn-primary(type="submit", data-testid="-btn-edit") 変更
            button.btn.btn-default(type="button", @click.prevent="close") キャンセル

      app-modal(v-model="modalError.isOpen" type="warning")
        template(slot="title") エラー
        h4 ソーシャルサイトの変更に失敗しました。
        p(v-if="modalError.message") {{modalError.message}}
        template(slot="footer", slot-scope="{close}")
          button.btn.btn-default(type="button" @click="close()") 閉じる
</template>

<script>
import AppModal from '@/components/templates/AppModal'
import SocialView from '@/components/molecules/SocialView'
import SocialForm from '@/components/organisms/forms/SocialForm'
import RepositoryFactory from '@/repositories/RepositoryFactory'

const PersonRepository = RepositoryFactory.get('person')

export default {
  name: 'CardTabOverallSocials',
  components: { AppModal, SocialView, SocialForm },
  props: {
    /**
     * @var sid_person
     */
    value: { type: [String, Number], required: false, default: '' },
    editable: { type: Boolean, required: true }
  },
  data () {
    return {
      socials: {
        twitterId: '',
        blogUrl: ''
      },
      isFieldEditted: false,
      modalEdit: {
        isOpen: false,
        value: ''
      },
      modalError: {
        isOpen: false,
        message: ''
      }
    }
  },
  watch: {
    value (id) {
      if (id) {
        this.getData(id)
      }
    }
  },
  created () {
    if (this.value) {
      this.getData(this.value)
    }
  },
  methods: {
    getData (id) {
      const vm = this
      PersonRepository.getSocialInfo(id, this.isMgmt)
        .then(function (response) {
          const data = vm.getApiData(response).data
          vm.socials = data
        })
        .catch(function (error) {
          const message = vm.getErrorMessage(error) || 'ソーシャルサイトが取得できませんでした。'
          vm.showToast(message, { type: 'danger' })
          // vm.setErrorMessage(error)
        })
    },
    openModal () {
      this.modalEdit.value = Object.assign({}, this.socials) // 参照コピーではなく値コピー
      this.modalEdit.isOpen = true
    },
    submit () {
      const vm = this
      const id = this.value
      this.isFieldEditted = false
      PersonRepository.put(
        id,
        {
          twitter_id: this.modalEdit.value.twitter_id,
          blog_url: this.modalEdit.value.blog_url
        },
        this.isMgmt
      )
        .then(function (response) {
          if (vm.isApiSuccess(response)) {
            vm.socials = Object.assign({}, vm.modalEdit.value) // 参照コピーではなく値コピー
            vm.showToast('ソーシャルサイトを変更しました。', { type: 'success' })
            vm.modalEdit.isOpen = false
            vm.isFieldEditted = true

            // twitter_urlなどを再取得
            vm.getData(vm.value)
          }
        })
        .catch(function (error) {
          vm.modalError.message = error.message
          vm.modalError.isOpen = true
        })
    }
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/pages/box/CardTabOverallSocials.vue